
var accordion = (function(){
  
  var $accordion = $('.js-accordion');
  var $accordion_header = $accordion.find('.js-accordion-header');
  var $accordion_item = $('.js-accordion-item');
 
  // default settings 
  var settings = {
    // animation speed
    speed: 400,
    
    // close all other accordion items if true
    oneOpen: false
  };
    
  return {
    // pass configurable object literal
    init: function($settings) {
      $accordion_header.on('click', function() {
        accordion.toggle($(this));
      });
      
      $.extend(settings, $settings); 
      
      // ensure only one accordion is active if oneOpen is true
      if(settings.oneOpen && $('.js-accordion-item.active').length > 1) {
        $('.js-accordion-item.active:not(:first)').removeClass('active');
      }
      
      // reveal the active accordion bodies
      $('.js-accordion-item.active').find('> .js-accordion-body').show();
    },
    toggle: function($this) {
            
      if(settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
        $this.closest('.js-accordion')
               .find('> .js-accordion-item') 
               .removeClass('active')
               .find('.js-accordion-body')
               .slideUp()
      }
      
      // show/hide the clicked accordion item
      $this.closest('.js-accordion-item').toggleClass('active');
      $this.next().stop().slideToggle(settings.speed);
    }
  }
})();

$(document).ready(function(){
  accordion.init({ speed: 300, oneOpen: true });
});


/*cart customizations */

$('#addInstructions').change(function()
      {
  if ($('#addInstructions').is(':checked')) {
        $("#cartnotesfields").show();
    }
  else {  $("#cartnotesfields").hide(); }
  });
  
     $("#datepicker").datepicker({
  minDate: 0,
    beforeShowDay: function(date) {
        var day = date.getDay();
        return [(day != 0  && day != 4 && day != 5 && day != 6)];
    }
});

        function updatenote(){ 
          datejson = ""; notevalue = "";
          if($('#datepicker').val()){
           datejson =  '{"requestShippingDate": "'+$("#datepicker").val()+'"}';        
          }
          
         var str = $("#note").val();
    str = str.replace(/[{}]/g, "");
       
          
        $("#actualnote").val( str + ' ' + datejson);
        }
        

$('.feat-collections__container--mobile').flickity({
  pageDots: true
});


/* about us scroll */
var aboutImage1 = $('#about-us-image-1');

$(window).scroll(function() {
  if(aboutImage1.length > 0){
    var distance1 = aboutImage1.offset().top +100;
    if ($(this).scrollTop() >= distance1 ) {
		$('#about-us-content-1').slideDown( "slow" );
    } else {
      	$('#about-us-content-1').slideUp( "slow" );
    }
  }
});

var aboutImage2 = $('#about-us-image-2');

$(window).scroll(function() {
  if(aboutImage2.length > 0){
    var distance2 = aboutImage2.offset().top +100;
    if ($(this).scrollTop() >= distance2 ) {
		$('#about-us-content-2').slideDown( "slow" );
    } else {
      	$('#about-us-content-2').slideUp( "slow" );
    }
  }
});

var aboutImage3 = $('#about-us-image-3');

$(window).scroll(function() {
  if(aboutImage3.length > 0){
    var distance3 = aboutImage3.offset().top +100;
    if ($(this).scrollTop() >= distance3 ) {
		$('#about-us-content-3').slideDown( "slow" );
    } else {
      	$('#about-us-content-3').slideUp( "slow" );
    }
  }
});

var aboutImage4 = $('#about-us-image-4');

$(window).scroll(function() {
  if(aboutImage4.length > 0){
    var distance4 = aboutImage4.offset().top +100;
    if ($(this).scrollTop() >= distance4 ) {
		$('#about-us-content-4').slideDown( "slow" );
    } else {
      	$('#about-us-content-4').slideUp( "slow" );
    }
  }
});


$( '.marquee' ).marquee({duration: window.innerWidth * 25, duplicated: true, startVisible : true, gap: 0});